// File: src/components/Icons/PublicIcon.tsx

import React from "react";

const normalizeUrl = (value: string): string => value.replace(/\/+$/, "");

const getWidgetAssetBaseUrl = (): string => {
    const widgetScripts = document.querySelectorAll('script[src*="widget.js"]');
    if (widgetScripts.length === 0) return "";

    const lastScript = widgetScripts[widgetScripts.length - 1] as HTMLScriptElement;
    if (!lastScript.src) return "";

    try {
        const scriptUrl = new URL(lastScript.src);
        const basePath = scriptUrl.pathname.replace(/\/widget\/widget\.js$/, "");
        return normalizeUrl(`${scriptUrl.origin}${basePath}`);
    } catch {
        return "";
    }
};

const getFaviconUrl = (): string => {
    const widgetAssetBaseUrl = getWidgetAssetBaseUrl();
    return widgetAssetBaseUrl ? `${widgetAssetBaseUrl}/favicon_public.ico` : "/favicon_public.ico";
};

export const PublicIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
    <img
        src={getFaviconUrl()}
        alt="Public Assistant"
        style={{
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: "4px",
            objectFit: "contain",
            // background: "#ffffff",
            padding: "2px"
        }}
    />
);

// Alternative SVG version if favicon doesn't load well
export const PublicIconSVG: React.FC<{ size?: number }> = ({ size = 24 }) => (
    <div
        style={{
            width: `${size}px`,
            height: `${size}px`,
            borderRadius: "4px",
            background: "#e74c3c",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontWeight: "bold",
            fontSize: `${size * 0.6}px`,
            color: "#ffffff"
        }}
    >
        P
    </div>
);

export default PublicIcon;
